import React from "react";
import LayoutContentCenteredWithBackground from "../../components/Layouts/ContentCenteredWithBackgroundLayout";
import AcceptInviteForm from "./AcceptInviteForm";

const route = "/accept-invitation/:token";

function AcceptInviteContainer() {
  return (
    <LayoutContentCenteredWithBackground>
      <AcceptInviteForm />
    </LayoutContentCenteredWithBackground>
  );
}

AcceptInviteContainer.route = route;

export default AcceptInviteContainer;
